import { render, staticRenderFns } from "./SendBugPage.vue?vue&type=template&id=f84adbec&"
import script from "./SendBugPage.vue?vue&type=script&lang=js&"
export * from "./SendBugPage.vue?vue&type=script&lang=js&"
import style0 from "./SendBugPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports